import { createContext, useContext, useState } from "react";

const ServiceContext = createContext(null);

const ServiceContextWrapper = ({ children }) => {
  const [shareData, setShareData] = useState({
    test: "some",
    chatgptResponse: "asd",
  });

  return (
    <ServiceContext.Provider value={{ shareData, setShareData }}>
      {children}
    </ServiceContext.Provider>
  );
};

export const useSharedContext = () => {
  const data = useContext(ServiceContext);
  return data;
};

export default ServiceContextWrapper;
